export const DefaultEnableGimbalControl = false;

export const gimbalStatesInfo = {
    status: {
        topic: "/gimbal/status",
        default: "UNKNOWN",
    },
    state: {
        topic: "/gimbal/status/angle",
        type: "geometry_msgs/Vector3",
        default: { yaw: 0.0, pitch: 0.0 },
        // gimbal node publishes a Vector3 (x=yaw, y=pitch, z=roll deg); we only track yaw/pitch.
        transform: (d) => ({ yaw: Number(d?.x ?? 0), pitch: Number(d?.y ?? 0) }),
    },
};
